/**
 * Wrapper halaman admin — spacing, lebar, dan loading konsisten.
 */
const PageLayout = ({
    children,
    narrow = false,
    loading = false,
    className = '',
}) => {
    const widthClass = narrow ? 'mx-auto max-w-3xl' : '';

    if (loading) {
        return (
            <div className={`page-loading ${widthClass} ${className}`.trim()}>
                <div
                    className="h-8 w-8 animate-spin rounded-full border-2 border-hairline border-t-primary"
                    role="status"
                    aria-label="Memuat"
                />
            </div>
        );
    }

    return (
        <div className={`space-y-4 pb-8 ${widthClass} ${className}`.trim()}>
            {children}
        </div>
    );
};

export default PageLayout;
